/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { ObjectSelector } from '../ObjectSelector';
/**
 * manage all user inputs (mouse, touch etc.)
 */
export class Controls {
    /**
     * constructor
     * @param canvasElement the canvas that shows the stage
     * @param eventWatcher watcher to detect number of listeners (for optimizations)
     */
    constructor(canvasElement, eventWatcher) {
        this._navigatorFactoryMap = new Map();
        this._navigatorEnabled = true;
        this._selector = new ObjectSelector(this, canvasElement, eventWatcher);
        this.enableNavigator(true);
    }
    /**
     * adds a new navigator
     * @param controlName name of the navigator
     * @param factory factory to create the new navigator
     */
    addNavigatorFactory(controlName, factory) {
        if (!this._currentNavigatorName) {
            this._currentNavigatorName = controlName;
        }
        this._navigatorFactoryMap.set(controlName, factory);
    }
    /**
     * disables all navigators
     * @param enabled
     */
    enableNavigator(enabled) {
        this._navigatorEnabled = enabled;
        if (!!this._currentNavigator) {
            this._currentNavigator.enable(enabled);
        }
    }
    pauseNavigator(enabled) {
        if (!!this._currentNavigator) {
            this._currentNavigator.enable(this._navigatorEnabled && !enabled);
        }
    }
    enableDragAndDrop(on) {
        this._selector.enableDragAndDrop(on);
    }
    /**
     * updates for the navigator (called before rendering)
     */
    update() {
        if (this._navigatorEnabled && !!this._currentNavigator) {
            this._currentNavigator.update();
        }
    }
    /**
     * selects the current or another (selected by navigator name) navigator with a new camera and/or scene
     * @param camera
     * @param scene
     * @param navigator
     */
    selectFor(camera, scene, navigator) {
        this._selectForNavigator(camera, scene, navigator);
        this._selectForObjectSelector(camera, scene);
    }
    _createNavigator(name, camera, scene) {
        const factory = this._navigatorFactoryMap.get(name);
        if (factory) {
            return factory.build(camera, scene);
        }
        return undefined;
    }
    _selectForNavigator(camera, scene, navigator) {
        if (!!this._currentNavigator) {
            this._currentNavigator.dispose();
        }
        this._currentNavigator = this._createNavigator(navigator || this._currentNavigatorName, camera, scene);
    }
    _selectForObjectSelector(camera, scene) {
        this._selector.setCurrentCamera(camera);
        this._selector.setCurrentScene(scene);
    }
}
//# sourceMappingURL=Controls.js.map